import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import main_en from "./translations/en/main.json";
import invoices_en from "./translations/en/invoices.json";
import errorMessages_en from "./translations/en/errorMessages.json";
import claimsInvoicesOverview_en from "./translations/en/claimsInvoicesOverview.json";
import externalLanding_en from "./translations/en/externalLading.json";
import common_en from "./translations/en/common.json";

const resources = {
    en: {
        main: main_en,
        invoices: invoices_en,
        errorMessages: errorMessages_en,
        claimsInvoicesOverview: claimsInvoicesOverview_en,
        externalLanding: externalLanding_en,
        common: common_en
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    ns: ["main", "invoices", "errorMessages", "claimsInvoicesOverview", "externalLanding", "common"],
    defaultNS: "main",
    load: "languageOnly",
    returnNull: false,
    returnEmptyString: false
});

export default i18n;
